//@flow

type SeverityType = {[severity: string]: number};

const Severity: SeverityType = {
  /**
   * An error occurred, but the Player is attempting to recover from the error.
   *
   * If the Player cannot ultimately recover, it still may not throw a CRITICAL
   * error.  For example, retrying for a media segment will never result in
   * a CRITICAL error (the Player will just retry forever).
   */
  RECOVERABLE: 1,
  /**
   * A critical error that the library cannot recover from.  These usually cause
   * the Player to stop loading or updating.  A new manifest must be loaded
   * to reset the library.
   */
  CRITICAL: 2
};

export {Severity};
export type {SeverityType};



// WEBPACK FOOTER //
// ./util/error/severity.js


// WEBPACK FOOTER //
// providers/util/error/severity.js